import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export interface SimpleInputDialogData {
  title?: string;
  label?: string;
  placeholder?: string;
  value?: string;
}

@Component({
  selector: 'simple-input-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule
  ],
  templateUrl: './simple-input-dialog.component.html',
  styleUrl: './simple-input-dialog.component.scss'
})
export class SimpleInputDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<SimpleInputDialogComponent>, { optional: true });
  readonly data = inject<SimpleInputDialogData>(MAT_DIALOG_DATA, { optional: true });

  onCancel() {
    this.dialogRef?.close();
  }

  onSendValue(value: string) {
    this.dialogRef?.close(value.trim());
  }
}
